import { Outlet } from "react-router-dom";
import ScrollToTopComponent from "src/components/scroll-to-top";
import HeaderResaleComponent from "src/components/header-resale";
import "./index.scss";
import FooterComponent from "src/components/footer";

function SallerProfileLayout() {
  return (
    <div className="saller-profile-layout">
      <HeaderResaleComponent />
      <Outlet />
      <FooterComponent />
      <ScrollToTopComponent />
    </div>
  );
}

export default SallerProfileLayout;
